import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  AppBar,
  Toolbar,
  IconButton,
  Alert,
} from '@mui/material';
import {
  ArrowBack as BackIcon,
  Dashboard as DashboardIcon,
  Person as PersonIcon,
  Category as CategoryIcon,
  Inventory as ProductIcon,
  Settings as SettingsIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import TopesDescuentoDashboard from './topes-descuento/TopesDescuentoDashboard';
import TopesCliente from './topes-descuento/TopesCliente';
import TopesClienteRubro from './topes-descuento/TopesClienteRubro';
import TopesClienteProducto from './topes-descuento/TopesClienteProducto';
import ConfiguracionTopes from './topes-descuento/ConfiguracionTopes';
import ConsultaTopes from './topes-descuento/ConsultaTopes';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tope-descuento-tabpanel-${index}`}
      aria-labelledby={`tope-descuento-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const TopesDescuentoComponent: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const tabs = [
    { label: 'Dashboard', icon: <DashboardIcon />, component: <TopesDescuentoDashboard /> },
    { label: 'Consulta', icon: <SearchIcon />, component: <ConsultaTopes /> },
    { label: 'Por Cliente-Producto', icon: <ProductIcon />, component: <TopesClienteProducto /> },
    { label: 'Por Cliente-Rubro', icon: <CategoryIcon />, component: <TopesClienteRubro /> },
    { label: 'Por Cliente', icon: <PersonIcon />, component: <TopesCliente /> },
    // { label: 'Configuración', icon: <SettingsIcon />, component: <ConfiguracionTopes /> }, // OCULTADO
  ];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton color="inherit" onClick={() => navigate('/dashboard')}>
            <BackIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Gestión de Topes de Descuento
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 3 }}>
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="body1" color="text.secondary" paragraph>
              Gestiona los topes de descuento por cliente, rubro y producto específico. 
              El sistema aplica una jerarquía de prioridades para determinar el tope final.
            </Typography>
            
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body2">
                <strong>Jerarquía de Prioridades:</strong>
              </Typography>
              <Typography variant="body2">
                1. Cliente + Producto específico (Máxima prioridad)
              </Typography>
              <Typography variant="body2">
                2. Cliente + Rubro (Prioridad media)
              </Typography>
              <Typography variant="body2">
                3. Cliente general (Prioridad baja)
              </Typography>
              <Typography variant="body2">
                4. Tope por defecto (Mínima prioridad)
              </Typography>
            </Alert>
          </CardContent>
        </Card>

        <Card>
          <CardContent sx={{ p: 0 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs 
                value={tabValue} 
                onChange={handleTabChange} 
                variant="scrollable"
                scrollButtons="auto"
                sx={{ px: 2 }}
              >
                {tabs.map((tab, index) => (
                  <Tab
                    key={index}
                    label={tab.label}
                    icon={tab.icon}
                    iconPosition="start"
                    id={`tope-descuento-tab-${index}`}
                    aria-controls={`tope-descuento-tabpanel-${index}`}
                  />
                ))}
              </Tabs>
            </Box>

            {tabs.map((tab, index) => (
              <TabPanel key={index} value={tabValue} index={index}>
                {tab.component}
              </TabPanel>
            ))}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default TopesDescuentoComponent;
